export default "__VITE_ASSET__BgKJLcLa__"